<template>
    <div>

        <div style="width:350px;margin:0 auto">
            <img :src="url" class="paytmimg" alt="">
            <div class="caption" style="text-align:center;color:blue" >Flat 0% Commission</div>
            <v-text-field
                type="text"
                style="width:350px;margin:0 auto;height:60px"
                label="Yesbank Loaded Amount"
                v-model="amount"
                solo />
            <v-text-field
                type="text"
                style="width:350px;margin:0 auto;height:60px"
                label="Yesbank Transaction ID"
                v-model="id"
                solo />
            <div style="width:100%;float:left;height:80px;">
                <v-btn color="primary" style="width:350px;margin:0 auto;" @click="submit">Pay Now</v-btn>
                <div class="body-2" style="text-align:center;width:100%">OR</div>
                <v-btn color="primary" style="width:350px;margin:0 auto;" @click="opencollect">Send Collect Request</v-btn>
                <v-btn  style="width:350px;margin:0 auto;" color="error"  flat >{{charge}}</v-btn>

            </div>
        </div>
            <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
            <v-dialog v-model="collect" width="500">
                <v-card >
                    <v-card-title style="height:40px">
                    <span class="body-2">Bank UPI ID List</span>
                    </v-card-title>
                            <v-card-text style="padding-top:0px">
                    </v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="upilist"
                        >
                        <template slot="items" slot-scope="props">
                            <td >{{ props.item.upi }}</td>
                            <td >{{ props.item.name }}</td>
                            <td><v-btn @click="send(props.item)" small color="primary">Request</v-btn></td>
                        </template>
                        </v-data-table>

                    </v-card>
                </v-dialog>
                <v-dialog
                v-model="sendmodel"
                width="300" height="300">
                        <v-card >
                                <v-card-title>Enter Details</v-card-title>
                                       <v-divider></v-divider>
                                        <v-card-text>
                                                <v-text-field
                                                type="number"
                                                style="width:200px;margin:0 auto;height:60px;"
                                                label="Amount"
                                                v-model="samount"
                                                solo
                                                />
                                                <v-text-field
                                                type="text"
                                                style="width:200px;margin:0 auto;height:60px;"
                                                label="Remark"
                                                v-model="remark"
                                                solo
                                                />
                                                <v-btn color="primary" @click="sendrequest" style="width:200px;margin-left:35px">Submit</v-btn>

                                        </v-card-text>

                                </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    props:['charge','url'],
    data(){
        return{
            id:"",
            amount:"",
            collect:false,
            sendmodel:false,
            dialog:false,
             headers: [
                { text: 'UPI', value: 'upi',align: 'left',sortable: false, },
                { text: 'User Name', value: 'name' },
                { text: 'Action', value: 'action' },
            ],
            upilist:[],
            request:[],
            samount:'',
            remark:''
        }
    },
    computed:{
        user(){
            return this.$store.getters.user
        }
    },
    mounted(){
        let vm = this;
        vm.getyesbankupi();
    },
    methods:{
        opencollect(){
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            vm.collect = true;
        },
        notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
            })
        },
        send(item){
            let vm = this;
            vm.collect = false;
            vm.request = item;
            vm.sendmodel = true;
        },
        sendrequest(){
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            if(vm.samount=="")return vm.notification("error","Amount Required")
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Bank_Upi_Id':vm.request.upi,
                'Source':'json',
                'Amount':vm.samount,
                'remark':vm.remark
            }
            vm.sendmodel = false;
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                    url:"YesBank_Collect_Amount",
                    data:doc,
            }).then(function (res) {
                    vm.dialog = false;
                    vm.$store.dispatch("getbalance")
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.request =[];
                       vm.samount ="";
                       return vm.notification("success",res.data.Message);
                    }
                    return vm.notification("error",res.data.Message);

            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error.message);
                    vm.dialog = false;
            })

        },
        getyesbankupi(){
                let vm = this;
                if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
                let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                }
                    vm.dialog = true;
                    vm.$store.dispatch("axiospost",{
                        url:"GetList_Of_YesBankUPI_ID",
                        data:doc,
                    }).then(function (res) {
                        vm.dialog = false;
                        vm.viewstatus =true;
                        let docs=res.data;
                        vm.upilist=[];
                        for(let i =0;i<docs.length;i++){
                            vm.upilist.push({
                                upi:docs[i].UpiId,
                                name:docs[i].User_Name,
                            });
                        }
                    }).catch(function (error) {
                        vm.notification("error",error.message);
                        vm.dialog = false;
                    })

        },
        submit(){
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            if(vm.amount=="")return vm.notification("error","Amount Required")
            if(vm.id=="")return vm.notification("error","Transaction ID Required")
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'PaymentMode':'yesbankupi',
                'PaymentType':'upi',
                'TransId':vm.id,
                'Amount':vm.amount,
                'Mode':'Load'
            }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                    url:"Load_Balance",
                    data:doc,
            }).then(function (res) {
                    console.log(res);
                    vm.dialog = false;
                    vm.$store.dispatch("getbalance")
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.id ="";
                       vm.amount ="";
                       return vm.notification("success",res.data.Message);
                    }
                    return vm.notification("error",res.data.Message);

            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error.message);
                    vm.dialog = false;
            })

        }
    }
}
</script>

<style scoped>
.paytmimg{
        width: 170px;
        margin-left:85px;
        }
</style>

